import { actionsFromList } from '@mgc/map-client-shared/lib/ReduxTools';
import strings from '../strings';
import { formatString } from '../format';
import ErrorActions from '../actions/error';
import OfferActions from './offer';

export default class SiteActions {
    static types = actionsFromList([
        'REQUESTING_SITES',
        'RECEIVED_SITES',
        // 'REQUESTING_SITE',
        // 'RECEIVED_SITE',
        'SELECT_SITE',
        'SHOW_ALERT',
        'SET_SERVER_ID',
        'SET_HOST_ID',
        'SET_MESSAGE',
        'SET_ALERT_ERROR_TYPE',
        'SET_ALERT_MESSAGE',
    ]);

    // async

    static validateThroughLightHouseAPI =
        (siteId, hostId, serverId, offerId) => (dispatch, getState) => {
            let params = {
                siteId: siteId,
                hostId: hostId,
                serverId: serverId,
                offerId: offerId
            };
            const validationUrl = '/site/host/server/validate';                
            const state = getState();

            state.api
                .validateSiteHostServerInfo(validationUrl, params)
                .then((response) => {
                    if (response.data.isValidationFailed == true) {
                        dispatch(
                            SiteActions.setErrorMessage(
                                JSON.stringify(response.data.errorResponse),
                                strings.danger
                            )
                        );
                        dispatch(SiteActions.showAlert(true));                        
                    } else {
                        dispatch(
                            SiteActions.setErrorMessage(
                                JSON.stringify(["Server / Host successfully added to the site"]),
                                strings.success
                            )
                        );
                        dispatch(SiteActions.showAlert(true)); 
                        //refreshing the offers to load the new server and host
                        dispatch(OfferActions.requestOffers());                       
                    }
                })
                .catch((error) => dispatch(ErrorActions.catchError(error)));
        };

    static fetchSites = () => (dispatch, getState) => {
        const state = getState();

        dispatch(SiteActions.requestingSites());

        state.api
            .getAllSites()
            .then((response) =>
                dispatch(SiteActions.receivedSites(response.data))
            )
            .catch((error) => dispatch(ErrorActions.catchError(error)));
    };

    static fetchSitesForUserAccount = () => (dispatch, getState) => {
        const state = getState();

        dispatch(SiteActions.requestingSites());

        state.api
            .getAllSitesForUser()
            .then((response) =>
                dispatch(SiteActions.receivedSites(response.data))
            )
            .catch((error) => dispatch(ErrorActions.catchError(error)));
    };

    // sync

    static requestingSites = () => ({
        type: SiteActions.types.REQUESTING_SITES,
    });

    static receivedSites = (response) => ({
        type: SiteActions.types.RECEIVED_SITES,
        payload: { response },
    });

    // static selectSite = (siteId) => ({
    //     type: SiteActions.types.SELECT_SITE,
    //     payload: { siteId },
    // });

    static selectSite = function (siteId) {
        return {
            type: SiteActions.types.SELECT_SITE,
            payload: { siteId },
        };
    };

    static showAlert = function (showAlert) {
        var action_obj = {
            type: SiteActions.types.SHOW_ALERT,
            payload: { showAlert },
        };
        return action_obj;
    };

    static setServerId = (serverId) => ({
        type: SiteActions.types.SET_SERVER_ID,
        payload: { serverId },
    });

    static setHostId = (hostId) => ({
        type: SiteActions.types.SET_HOST_ID,
        payload: { hostId },
    });

    static setErrorMessage = function (message, errorType) {
        var action_obj = {
            type: SiteActions.types.SET_ALERT_MESSAGE,
            payload: { message, errorType },
        };
        return action_obj;
    };

    static downloadServersBySiteList = (offerId) => (dispatch, getState) => {
        const state = getState();
        const filename = `${strings.ServersBySite}.xlsx`;
        // dispatch(UploadConfigurationActions.setDownloadSpinner(true));
        // dispatch(OrderActions.downloadingConfigurationProductList());

        state.api
            .downloadServersBySiteList(offerId, filename)
            .then(() => {
                // OrderActions.downloadedConfigurationProductList();
                // dispatch(UploadConfigurationActions.setDownloadSpinner(false));
            })
            .catch(ErrorActions.errorHandler(dispatch));
    };
}



// WEBPACK FOOTER //
// ./app/actions/sites.js